import { Box } from "@chakra-ui/react"
import Card from "@pathwright/ui/src/components/card/Card"
import { LightMode } from "@pathwright/ux/src/components/chakra/ui/color-mode"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { usePathwrightContext } from "@pathwright/features/src/modules/pathwright/PathwrightContext"
import { useRef } from "react"
import LazyPasswordChangeContainer from "./LazyPasswordChangeContainer"

const PasswordCard = ({ card }) => {
  const { t } = useTranslate()
  const { me } = usePathwrightContext()
  // Store the initial value of no_password_set to avoid re-rendering
  // when the password is changed, so as to let the LazyPasswordChangeContainer
  // handle success state.
  const initialHasPassword = useRef(!me.no_password_set).current

  return (
    <Card
      // title={t("password_form.card_title")}
      card={card}
    >
      <LightMode>
        <Box className="chakra-ui-reset-css" p="30px" pt={0}>
          <LazyPasswordChangeContainer hasPassword={initialHasPassword} />
        </Box>
      </LightMode>
    </Card>
  )
}

PasswordCard.displayName = "PasswordCard"

export default PasswordCard
